import { InputProps } from "types/html";
import classNames from "classnames";
import { forwardRef } from "react";

import { MediumText } from "components/MediumText/MediumText";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";
import { RegularText } from "components/RegularText/RegularText";

import styles from "./styles.module.scss";

type NamedInputProps = InputProps & {
  name?: string;
  label?: string;
  isLabelRegular?: boolean;
  placeholder?: string;
  inputWidth?: number;
  className?: string;
  labelClassName?: string;
  classNameContainer?: string;
  value?: string | number;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  isRequired?: boolean;
  hasError?: boolean;
  errorMessage?: string;
  disabled?: boolean;
};

export const NamedInput = forwardRef<HTMLInputElement, NamedInputProps>(
  (props: NamedInputProps, ref): JSX.Element => {
    const {
      label,
      isLabelRegular,
      placeholder,
      className,
      labelClassName,
      type,
      isRequired,
      hasError,
      errorMessage,
      ...rest
    } = props;

    return (
      <div className={`flex flex-col ${props.classNameContainer}`}>
        <div className="flex items-center text-nowrap justify-between">
          {!!label && (
            <>
              {isLabelRegular ? (
                <RegularText className={labelClassName}>{label}:</RegularText>
              ) : (
                <MediumText className={labelClassName}>{label}:</MediumText>
              )}
              {!labelClassName && <HorizontalSpace size={16} />}
            </>
          )}
          <input
            ref={ref}
            style={{ width: props.inputWidth }}
            type={type}
            className={classNames(styles.input, className, {
              [styles["error-border"]]: hasError,
            })}
            placeholder={placeholder}
            required={isRequired}
            {...rest}
          />
        </div>
        {hasError && (
          <p className="text-red-500 mt-1 text-sm">{errorMessage}</p>
        )}
      </div>
    );
  }
);
